var Vue, initVueComponents, vueComponents;

Vue = require('./vue-with-plugins');

vueComponents = require('./vue-components');

initVueComponents = function() {
  return $('[data-component]').each(function() {
    var $this, components;
    $this = $(this);
    components = $this.data('component');
    if (components) {
      components = _.compact(components.split(' '));
      if (components.length) {
        $this.removeAttr('data-component');
        return new Vue({
          el: this,
          components: _.object(_.map(components, function(component) {
            return [component, vueComponents[component]];
          }))
        });
      }
    }
  });
};

$(function() {
  initVueComponents();
  return $(document).ajaxSuccess(initVueComponents);
});

